module.exports = __webpack_public_path__ + "static/media/judge.4e96362d.png";